module.exports = __webpack_public_path__ + "static/media/observe_incident.0a880418.png";